<template>
  <div class="base-basic">
    <!-- 顶部用户信息区域 -->
    <div class="user-info-header">
      <div class="avatar-container">
        <van-icon name="user-o" size="48" color="#fff" />
      </div>
      <div class="user-details">
        <div class="user-name">{{ userInfo.name || '未设置' }}</div>
        <div class="user-phone">{{ userInfo.phone || '未设置' }}</div>
      </div>
    </div>

    <!-- 页面主体内容 -->
    <div class="body-content">
      <!-- 功能选项卡片 - 浮在蓝色框上方 -->
      <div class="function-card">
        <div class="function-list">
          <van-cell title="个人信息" is-link @click="navigateTo('personal-info')">
            <template #icon>
              <img src="/assets/profile/personal-info.png" alt="个人信息" class="profile-icon" />
            </template>
          </van-cell>
          <van-cell title="修改密码" is-link @click="navigateTo('password-change')">
            <template #icon>
              <img src="/assets/profile/pwd.png" alt="修改密码" class="profile-icon" />
            </template>
          </van-cell>
          <van-cell title="项目组信息" is-link @click="navigateTo('project-info')">
            <template #icon>
              <img src="/assets/profile/project-info.png" alt="项目组信息" class="profile-icon" />
            </template>
          </van-cell>
          <van-cell title="意见反馈" is-link @click="navigateTo('feedback')">
            <template #icon>
              <img src="/assets/profile/feedback.png" alt="意见反馈" class="profile-icon" />
            </template>
          </van-cell>
        </div>
      </div>

    </div>

    <!-- ICP备案号 -->
    <div class="profile-icp">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
        浙ICP备2026001625号
      </a>
    </div>

    <!-- 退出登录按钮 - 固定在页面最底部 -->
    <div class="logout-button-container">
      <van-button type="primary" block @click="handleLogout">退出登录</van-button>
    </div>
  </div>
</template>

<script>
import { Button, Cell, CellGroup, Icon } from 'vant';

export default {
  name: 'ProfilePage',
  components: {
    VanButton: Button,
    VanCell: Cell,
    VanCellGroup: CellGroup,
    VanIcon: Icon
  },
  data() {
    return {
      userInfo: {}
    };
  },
  created() {
    this.loadUserInfo();
  },
  methods: {
    loadUserInfo() {
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        this.userInfo = JSON.parse(userInfo);
      } else {
        this.$router.push('/login');
      }
    },
    handleLogout() {
      localStorage.removeItem('userInfo');
      this.$router.push('/login');
    },

    navigateTo(path) {
      // 根据传入的路径进行路由导航
      this.$router.push(`/${path}`);
    }
  }
};
</script>

<style scoped>
/* 全局页面基础样式 */
.base-basic {
  background-color: #f7f8fa;
  min-height: 100vh;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  display: flex;
  flex-direction: column;
}

/* 页面主体内容 */
.body-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* 顶部用户信息区域 */
.user-info-header {
  background-color: #145294;
  padding: 30px 0 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
}

.avatar-container {
  width: 80px;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.user-name {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}

.user-phone {
  font-size: 14px;
  opacity: 0.9;
}

/* 功能选项卡片 */
.function-card {
  margin-top: -40px;
  padding: 0 15px;
  z-index: 10;
  position: relative;
}

/* 功能选项列表 */
.function-list {
  background-color: #fff;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.function-list .van-cell {
  border-bottom: 1px solid #f5f5f5;
  padding: 16px 15px;
}

.function-list .van-cell:last-child {
  border-bottom: none;
}

.function-list .van-cell__title {
  font-size: 15px;
  color: #333;
}

/* 功能选项图标样式 */
.profile-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* 退出登录按钮 */
.logout-button-container {
  padding: 20px 15px;
  margin-top: 20px;
  margin-bottom: 50px;
}

.logout-button-container .van-button--primary {
  background-color: #145294;
  border-color: #145294;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
}


.profile-icp { text-align: center; padding: 15px 0 25px; font-size: 12px; }
.profile-icp a { color: #999; text-decoration: none; }
</style>